var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bothLocksON)?_c('p',{class:[
      _vm.caps_num_lock,
      _vm.addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
    ]},[_vm._m(0),_c('span',[_vm._v(" Caps & Num Lock is On ")])]):(_vm.capsLockON)?_c('p',{class:[
      _vm.caps_num_lock,
      _vm.addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
    ]},[_vm._m(1),_c('span',[_vm._v(" Caps Lock On ")])]):(_vm.numsLockON)?_c('p',{class:[
      _vm.caps_num_lock,
      _vm.addAlignment ? 'caps_num_lock_alignment' : 'caps_num_lock',
    ]},[_vm._m(2),_c('span',[_vm._v(" Num Lock On ")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cap_warning_icon"},[_c('img',{attrs:{"src":require("@/common/assets/styles/corp/images/caps_warning.png"),"alt":"caps_lock_warning_icon"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cap_warning_icon"},[_c('img',{attrs:{"src":require("@/common/assets/styles/corp/images/caps_warning.png"),"alt":"caps_lock_warning_icon"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cap_warning_icon"},[_c('img',{attrs:{"src":require("@/common/assets/styles/corp/images/caps_warning.png"),"alt":"caps_lock_warning_icon"}})])
}]

export { render, staticRenderFns }